module.exports = __webpack_public_path__ + "static/media/unknown.e55d42de.jpg";